module.exports = __webpack_public_path__ + "img/PMK_20210406_3.05edeb61.png";